import { DataTableColumnDef } from "@/components/molecules";
import { renderColumnHeaderWithTooltip } from "../helpers";
import { VehicleCategoryColumnHeader } from "../common/VehicleCategoryColumnHeader";
import { ArchivedVehicleTableData } from "./types";

export const archivedVehiclesColumns: DataTableColumnDef<ArchivedVehicleTableData>[] = [
  {
    header: "Year",
    accessorKey: "year",
    size: 100,
  },
  {
    header: "Make",
    accessorKey: "make",
    cell: (props) => props.row.original.make,
    size: 150,
  },
  {
    header: "Model",
    accessorKey: "model",
    size: 150,
  },
  {
    header: "Number Plate",
    id: "registration_number",
    accessorKey: "numberPlate",
    cell: (props) => props.row.original.numberPlate,
    size: 150,
  },
  {
    header: "Nickname",
    size: 150,
    id: "identifier",
    accessorKey: "nickname",
  },
  {
    header: renderColumnHeaderWithTooltip("Vehicle Type", "Operator-defined vehicle type used within your own fleet setup", "For internal bookings"),
    id: "vehicleType",
    accessorKey: "vehicleType",
    cell: (props) => props.row.original.vehicleType,
    size: 150,
    // Backend vehicle search only sorts on make/model/registration_number/year/identifier.
    enableSorting: false,
  },
  {
    header: VehicleCategoryColumnHeader,
    id: "vehicleCategory",
    accessorKey: "vehicleCategory",
    size: 175,
    enableSorting: false,
  },
  {
    header: "Actions",
    id: "actions",
    cell: (props) => props.row.original.actions,
    maxSize: 75,
  },
];
